import { schema, types } from 'papr'

export const publicationRecommendationSchema = schema({
	recommendingPublication: types.objectId({ required: true }),
	recommendedPublication: types.objectId({ required: true }),
	dateAdded: types.date({ required: true }),
	dateUpdated: types.date({ required: true }),
})

export type PublicationRecommendationDocument = (typeof publicationRecommendationSchema)[0]
export type PublicationRecommendationSchemaOptions = (typeof publicationRecommendationSchema)[1]
